<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m10.545 6.765.69.69L4.44 14.25h-.69v-.69l6.795-6.795Zm2.7-4.515a.75.75 0 0 0-.525.217L11.347 3.84l2.813 2.813 1.373-1.373a.747.747 0 0 0 0-1.058l-1.755-1.755a.736.736 0 0 0-.533-.217Zm-2.7 2.393L2.25 12.937v2.813h2.813l8.294-8.295-2.812-2.813Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
